
// export const base_URL = "http://157.245.108.131:8080";
export const base_URL = "https://stozy.ml";
// export const base_URL = "http://192.168.31.44:8080";
export const token = "token";
export const adminToken = "Authorization";
export const role = "role";
